import React, { useEffect, useRef, useState } from 'react';
import { ArrowRight, Bookmark, Download, Upload, Home } from 'lucide-react';
import LoopVideo, { filmSrc } from './loopVideo.jsx';
import ReelViewer from './reelViewer.jsx';
import { getSaved, subscribeSaved, exportBackup, importBackup, unsavedSinceBackup, isAccountSynced, BACKUP_FILE } from './savedStore.jsx';
import './savedPage.scss';

// «ذخیره‌شده‌ها» — فقط روی همین گوشی. فایلِ پشتیبان (khoonero-saved.json) برای بعد از حذف/نصبِ دوباره‌ی برنامه
const fa = (n) => Number(n).toLocaleString('fa-IR');

function SavedPage({ onClose }) {
  const [items, setItems] = useState(getSaved);
  const [pending, setPending] = useState(unsavedSinceBackup);
  const [open, setOpen] = useState(null);
  const [msg, setMsg] = useState('');
  const fileRef = useRef(null);

  useEffect(
    () =>
      subscribeSaved((list) => {
        setItems(list);
        setPending(unsavedSinceBackup());
      }),
    []
  );

  const handleBackup = async () => {
    setMsg('');
    const ok = await exportBackup();
    if (ok) setMsg(`فایلِ «${BACKUP_FILE}» روی گوشی ذخیره شد. نگهش دارید.`);
  };
  const handleRestore = async (file) => {
    if (!file) return;
    try {
      const n = await importBackup(file);
      setMsg(n ? `${fa(n)} موردِ ذخیره‌شده برگشت.` : 'همه‌ی موردهای این فایل از قبل این‌جا بودند.');
    } catch (e) {
      setMsg(e.message);
    }
  };

  return (
    <div className="saved-page">
      <header className="saved-page__header">
        <button type="button" onClick={onClose} aria-label="بازگشت">
          <ArrowRight size={22} strokeWidth={1.8} />
        </button>
        <strong>ذخیره‌شده‌ها</strong>
        <span />
      </header>

      {isAccountSynced() ? (
        <div className="saved-page__backup">
          <p>ذخیره‌ها روی حسابِ شما هم نگه داشته می‌شوند — با گوشیِ دیگر یا بعد از نصبِ دوباره، فقط وارد شوید.</p>
        </div>
      ) : (
      <div className="saved-page__backup">
        <p>
          ذخیره‌ها فقط روی همین گوشی است. برای این‌که با حذف و نصبِ دوباره‌ی برنامه از بین نروند، از آن‌ها
          پشتیبان بگیرید؛ بعد از نصبِ دوباره همان فایل را انتخاب کنید.
        </p>
        <div className="saved-page__backup-actions">
          <button type="button" onClick={handleBackup} disabled={!items.length}>
            <Download size={16} strokeWidth={2} />
            <span>پشتیبان‌گیری{pending > 0 && items.length ? ` (${fa(pending)} جدید)` : ''}</span>
          </button>
          <button type="button" onClick={() => fileRef.current && fileRef.current.click()}>
            <Upload size={16} strokeWidth={2} />
            <span>بازیابی از فایل</span>
          </button>
          <input
            ref={fileRef}
            type="file"
            accept="application/json,.json"
            hidden
            onChange={(e) => {
              handleRestore(e.target.files && e.target.files[0]);
              e.target.value = '';
            }}
          />
        </div>
        {msg && <p className="saved-page__msg">{msg}</p>}
        <p className="saved-page__msg">یا وارد حسابتان شوید تا ذخیره‌ها روی حساب هم بمانند.</p>
      </div>
      )}

      {items.length === 0 ? (
        <div className="saved-page__empty">
          <Bookmark size={30} strokeWidth={1.3} />
          <p>هنوز چیزی ذخیره نکرده‌اید. در اکسپلور، روی هر طرح دکمه‌ی «ذخیره» را بزنید.</p>
          <p className="saved-page__hint">اگر برنامه را دوباره نصب کرده‌اید، «بازیابی از فایل» را بزنید و فایلِ {BACKUP_FILE} را انتخاب کنید.</p>
        </div>
      ) : (
        <section className="saved-page__grid">
          {items.map((d, i) => (
            <button key={d.id} type="button" className="saved-page__cell" onClick={() => setOpen(i)}>
              {d.filmUrl ? <LoopVideo src={filmSrc(d, true)} poster={d.thumbUrl} threshold={0.5} /> : d.thumbUrl ? <img src={d.thumbUrl} alt="" /> : <Home size={22} />}
            </button>
          ))}
        </section>
      )}

      {open !== null && items[open] && <ReelViewer items={items} startIndex={open} onClose={() => setOpen(null)} />}
    </div>
  );
}

export default SavedPage;
